/* eslint-disable @next/next/no-img-element */
import classNames from '@sindresorhus/class-names';
import Link from 'next/link';
import {useEffect, useRef} from 'react';

import {Icon} from '@web-catalog/ui-kit/Icon';

import styles from './Chip.module.scss';

type Props = {
  active?: boolean;
  linkTo: string;
  label: string;
  iconComponent?: any;
  iconSrc?: string;
  iconColorVariant?: string;
  testId?: string;
  onClick: (active: boolean) => void;
};

export const Chip = ({
  linkTo,
  label,
  iconComponent,
  iconSrc,
  iconColorVariant,
  active,
  testId,
  onClick,
}: Props) => {
  const rootRef = useRef<HTMLAnchorElement>(null);
  useEffect(() => {
    if (active) {
      try {
        rootRef.current?.scrollIntoView({
          behavior: 'smooth',
          block: 'nearest',
          inline: 'center',
        });
      } catch (e) {
        console.error('Failed to scroll into view', e);
      }
    }
    // только на маунте - чтобы показать активный чип при изначальном заходе
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Link
      ref={rootRef}
      href={linkTo}
      prefetch={false}
      className={classNames(styles.root, active && styles.active)}
      onClick={() => onClick(!!active)}
      data-testid={testId}
    >
      {iconComponent && (
        <Icon svg={iconComponent} className={styles.iconComponent} />
      )}
      {iconSrc && (
        <img
          alt=""
          aria-hidden="true"
          src={iconSrc}
          loading="lazy"
          className={classNames(
            styles.icon,
            active && styles.activeIcon,
            !active &&
              iconColorVariant &&
              (styles as Record<string, string>)[iconColorVariant],
          )}
        />
      )}
      {label}
    </Link>
  );
};
